import { Button } from 'components/Button/Button';

type Props = {
  applied: boolean;
  onMarkAsApplied: () => Promise<void>;
  onMarkAsNotApplied: () => Promise<void>;
  className?: string;
};

export function ListingActionsDropdownMarkApplied({
  applied,
  onMarkAsApplied,
  onMarkAsNotApplied,
  className,
}: Props) {
  if (applied) {
    return (
      <Button
        type="button"
        data-qa-id="mark-not-applied-button"
        variant="link-grey"
        onClick={() => {
          void onMarkAsNotApplied();
        }}
        className={className}
        size="small"
      >
        {getText('Mark As Not Applied')}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      data-qa-id="mark-applied-button"
      variant="link-grey"
      onClick={() => {
        void onMarkAsApplied();
      }}
      className={className}
      size="small"
      icon={{ type: 'normalized', name: 'simple-check' }}
    >
      {getText('Mark As Applied')}
    </Button>
  );
}
